import React from 'react';

import { Link } from 'wouter';

import { cn } from '../../lib/utils';

export default function AuthField({ disabled, errorMessage, errorMessageId, field, hasError, onChange, onPaste, value }) {
  const inlineErrorId = `auth-field-${field.name}-error`;

  return (
    <div className="flex w-full flex-col gap-2">
      {/* Skipped entirely when there's nothing to show — an empty row would still
          spend the stack's gap above the input. */}
      {field.label || errorMessage || field.inlineLink ? (
        <div className="flex w-full items-center justify-between">
          {field.label ? (
            <label htmlFor={field.name} className="text-[13px] leading-5 text-gray-500">
              {field.label}
            </label>
          ) : null}
          {errorMessage ? (
            <p id={inlineErrorId} className="text-[13px] leading-5 text-red-500">
              {errorMessage}
            </p>
          ) : field.inlineLink ? (
            <Link
              href={field.inlineLink.href}
              className="text-xs leading-5 text-gray-400 hover:text-gray-500"
              data-app-region="none"
              tabIndex={-1}
            >
              {field.inlineLink.label}
            </Link>
          ) : null}
        </div>
      ) : null}

      <input
        aria-label={field.label ? undefined : field.ariaLabel}
        aria-describedby={hasError ? (errorMessage ? inlineErrorId : errorMessageId) : undefined}
        aria-invalid={hasError}
        autoComplete={field.autoComplete}
        disabled={disabled}
        id={field.name}
        inputMode={field.inputMode}
        maxLength={field.maxLength}
        name={field.name}
        onChange={onChange}
        onPaste={onPaste}
        pattern={field.pattern}
        placeholder={field.placeholder}
        required={field.required}
        type={field.type}
        value={value}
        className={cn(
          'h-12 w-full rounded-lg border border-gray-300 bg-gray-100 px-4 text-[15px] leading-5 text-black transition-colors outline-none placeholder:text-gray-400 hover:border-gray-400 hover:bg-[#eceef1] focus:border-black focus:bg-white disabled:cursor-not-allowed disabled:opacity-70 sm:border-[0.5px]',
          hasError && 'border-red-500 bg-red-50 hover:border-red-500 hover:bg-red-50 focus:border-red-500 focus:bg-red-50',
        )}
        data-app-region="none"
      />
    </div>
  );
}
